import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import get from 'lodash/get'
import kebabCase from 'lodash/kebabCase'

const IndexPage = props => {
  return (
    <div>
      <section className="actions grid-x grid-padding-x">
        <div className="cell small-12 medium-auto shrink">
          <h2>Get Involved:</h2>
        </div>
        <div className="cell auto shrink">
          <a
            className="button"
            href="https://forms.gle/XoGLErh2GKPgGT7u7"
            rel="noindex, nofollow, noopener"
          >
            Be a Mentor
          </a>
          <Link to="/sponsorship/" className="button">
            Sponsorship Info
          </Link>
          <a
            href="/files/YCMS-Feb-2020.pdf"
            download="YouthChangeMakerSummit Scottsdale 2020 Student Flyer.pdf"
            className="button"
          >
            Print Flyer
          </a>
        </div>
      </section>

      <section className="dark-gray grid-x grid-padding-x" id="facts">
        <div className="cell medium-6">
          <h2>CREATE EQUITY THROUGH ENTREPRENEURSHIP</h2>
          <p>
            Youth ChangeMaker Summit is a 3-day immersion in how to change the
            world through venture creation for high school students. To create
            the Arizona we want, we must empower all students to build solutions
            to the problems they experience in their home communities.
          </p>
          <p>
            In 2020, Youth ChangeMaker Summit will be empowering
            Scottsdale, Peoria and Goodyear youth to improve their community!
          </p>
        </div>
        <div className="cell medium-6 factoids">
          <div className="cell factoid">
            <p>
              <strong>42%</strong> Minority Students
            </p>
          </div>
          <div className="cell factoid">
            <p>
              <strong>500+</strong> Students Reached
            </p>
          </div>
          <div className="cell factoid">
            <p>
              <strong>15+</strong> Communities Reached
            </p>
          </div>
        </div>
      </section>
      {/* <section className="dark-gray grid-x grid-padding-x">
        <div className="cell medium-6">
          <div className="video-container">
            <iframe
              // width="560"
              // height="315"
              src="https://www.youtube.com/embed/2O9cUrhhJvc"
              frameBorder="0"
              allowFullScreen="1"
            />
          </div>
        </div>
        <div className="cell medium-6">
          <p>
            Youth ChangeMaker Summit is the chance for youth to see how
            impactful their ideas are and just how much hard work and
            determination is required to make that dream come to life.
          </p>
        </div>
      </section> */}
      <Helmet
        meta={[
          {
            name: 'og:title',
            content: 'Youth ChangeMaker Summit by the CO+HOOTS Foundation',
          },
          {
            name: 'og:description',
            content:
              'Youth ChangeMaker Summit is an entrepreneurship event for high school students.',
          },
          {
            name: 'og:image',
            content: '/img/bg-img.jpg',
          },
          {
            name: 'twitter:card',
            content: 'summary',
          },
          {
            name: 'twitter:site',
            content: '@ycmsummit',
          },
        ]}
      />
    </div>

    // <Helmet
    //   // title={site.siteMetadata.title}
    //   meta={[
    //     {
    //       name: 'description',
    //       content:
    //         'A reference site for iOS developers to quickly find links to relevant documentation and examples.',
    //     },
    //     {
    //       name: 'keywords',
    //       content:
    //         'ios, mobile, iphone, apps, developer, software development',
    //     },

    //     { name: 'twitter:card', content: 'summary' },
    //     { name: 'twitter:site', content: '@iosdevrecipes' },
    //     {
    //       name: 'twitter:title',
    //       content: 'iOS Dev Recipes',
    //     },
    //     {
    //       name: 'twitter:description',
    //       content: 'A reference site for iOS developers.',
    //     },
    //     {
    //       name: 'twitter:image',
    //       content: 'https://www.iosdev.recipes/img/logos/logo-2048.png',
    //     },
    //   {
    //     name: 'og:title',
    //     content: site.siteMetadata.title,
    //   },
    //   {
    //     name: 'og:description',
    //     content:
    //       'A reference site for iOS developers to quickly find links to relevant documentation and examples.',
    //   },
    //   {
    //     name: 'og:image',
    //     content: 'https://www.iosdev.recipes/img/logos/logo-2048.png',
    //   },
    // ]}
    // />
  )
}

export default IndexPage

export const query = graphql`
  query MainSectionsQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js